<template>
  <div>
    <div class="find">
      <div class="seach-top">
        <el-form
          ref="searchForm"
          :inline="true"
          :model="searchForm"
          class="demo-form-inline"
        >
          <el-form-item label="关键字：">
            <el-input
              v-model="searchForm.keyWord"
              placeholder="请输入查询内容"
              size="small"
            />
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              @click="GetPagedListGR01s"
            >
              查询
            </el-button>
          </el-form-item>
          <div
            class="btn-box"
            style="float: right;"
          >
            <el-form-item>
              <el-button
                type="primary"
                size="small"
                @click="dataAdd"
              >
                新增
                <i class="el-icon-plus el-icon--right" />
              </el-button>
            </el-form-item>
            <el-form-item>
              <upload-excel-component
                style="display:inline;"
                :on-success="handleSuccess"
                :before-upload="beforeUpload"
              />
            </el-form-item>
            <el-form-item>
              <el-button
                style="margin-left: 8px"
                size="small"
                type="primary"
                @click="exportFn()"
              >
                导出
                <i class="el-icon-download el-icon--right" />
              </el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>

    <el-table
      v-loading.lock="loading"
      class="table-list"
      :border="true"
      :data="tableData"
      style="width: 100%"
      element-loading-text="正在执行，请稍后......"
    >
      <el-table-column
        label="单位名称"
        width="200"
        show-overflow-tooltip
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.danWei }}</span>
            <el-input
              v-if="scope.row.isEdit"
              v-model="scope.row.danWei"
              size="small"
              placeholder="请输入单位名称"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="单位任务"
        width="200"
        show-overflow-tooltip
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.danWeiRenWu }}</span>
            <el-input
              v-if="scope.row.isEdit"
              v-model="scope.row.danWeiRenWu"
              size="small"
              placeholder="请输入单位任务"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="单位地址"
        width="200"
        show-overflow-tooltip
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.danWeiDiZhi }}</span>
            <el-input
              v-if="scope.row.isEdit"
              v-model="scope.row.danWeiDiZhi"
              size="small"
              placeholder="请输入单位地址"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="单位邮编"
        width="200"
        show-overflow-tooltip
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.danWeiYouBian }}</span>
            <el-input
              v-if="scope.row.isEdit"
              v-model="scope.row.danWeiYouBian"
              size="small"
              placeholder="请输入单位邮编"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="单位电话"
        width="200"
        show-overflow-tooltip
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.danWeiDianHua }}</span>
            <el-input
              v-if="scope.row.isEdit"
              v-model="scope.row.danWeiDianHua"
              size="small"
              placeholder="请输入单位电话"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="参与人员"
        width="200"
        show-overflow-tooltip
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.canYuRenYuan }}</span>
            <el-input
              v-if="scope.row.isEdit"
              v-model="scope.row.canYuRenYuan"
              size="small"
              placeholder="请输入参与人员"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="联系人"
        width="200"
        show-overflow-tooltip
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.lianXiRen }}</span>
            <el-input
              v-if="scope.row.isEdit"
              v-model="scope.row.lianXiRen"
              size="small"
              placeholder="请输入联系人"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="联系人地址"
        width="200"
        show-overflow-tooltip
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.lianXiRenDiZhi }}</span>
            <el-input
              v-if="scope.row.isEdit"
              v-model="scope.row.lianXiRenDiZhi"
              size="small"
              placeholder="请输入联系人地址"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="联系人邮编"
        width="200"
        show-overflow-tooltip
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.lianXiRenYouBian }}</span>
            <el-input
              v-if="scope.row.isEdit"
              v-model="scope.row.lianXiRenYouBian"
              size="small"
              placeholder="请输入联系人邮编"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="联系人电话"
        width="200"
        show-overflow-tooltip
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.lianXiRenDianHua }}</span>
            <el-input
              v-if="scope.row.isEdit"
              v-model="scope.row.lianXiRenDianHua"
              size="small"
              placeholder="请输入联系人电话"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="联系人邮箱"
        width="200"
        show-overflow-tooltip
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.lianXiRenYouXiang }}</span>
            <el-input
              v-if="scope.row.isEdit"
              v-model="scope.row.lianXiRenYouXiang"
              size="small"
              placeholder="请输入联系人邮箱"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="备注"
        width="200"
        show-overflow-tooltip
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.remarks }}</span>
            <el-input
              v-if="scope.row.isEdit"
              v-model="scope.row.remarks"
              size="small"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="150"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            v-if="!scope.row.isAdd"
            type="text"
            size="small"
            @click.native.prevent="DeleteGR01(scope.row.id, tableData)"
          >
            删除
          </el-button>
          <el-button
            v-if="!scope.row.isEdit"
            type="text"
            size="small"
            @click.native.prevent="editDate(scope.$index, scope.row)"
          >
            修改
          </el-button>
          <el-button
            v-if="scope.row.isEdit"
            type="text"
            size="small"
            @click.native.prevent="createOrUpdateGR01(scope.$index, scope.row)"
          >
            保存
          </el-button>
          <el-button
            v-if="scope.row.isEdit"
            type="text"
            size="small"
            @click.native.prevent="quxiao(scope.$index, scope.row)"
          >
            取消
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="totalCount"
      @current-change="changePage"
    />
  </div>
</template>

<script>
import pathReq from '@/api/pathlist'
import UploadExcelComponent from '@/components/UploadExcel/index.vue'

export default {
  name: 'Wanchengdanwei',
  components: {
    UploadExcelComponent
  },
  props: {
    postId: { type: Number, default: null }
  },
  // ['postId'],
  data() {
    return {
      tableHeader: [],
      totalCount: 0,
      tableData: [],
      page: 1,
      size: 10,
      parentId: this.postId,
      searchForm: {
        ParentId: this.postId
      },
      loading: true
    }
  },
  created() {
    this.GetPagedListGR01s()
    this.$bus.$off('show/danwei', this.GetPagedListGR01s)
    this.$bus.$on('show/danwei', this.GetPagedListGR01s)
  },
  mounted() {},
  methods: {
    // 切页
    changePage(page) {
      this.page = page
      this.GetPagedListGR01s()
    },
    // 新增
    dataAdd() {
      var dataNew = {}
      dataNew.isEdit = true
      dataNew.isAdd = true
      this.tableData.unshift(dataNew)
    },
    // 获取信息
    GetPagedListGR01s() {
      const that = this
      const path = '/api/services/app/jx0102/GetPagedListjx0102s'
      this.loading = true
      pathReq
        .dataList(path, this.page, this.size, this.searchForm)
        .then(res => {
          if (res.status === 200) {
            if (res.data.success) {
              that._data.totalCount = res.data.result.totalCount
              that._data.tableData = res.data.result.items
              this.loading = false
            }
          }
        })
    },
    // 编辑
    editDate(i, row) {
      row.isEdit = true
      this.$forceUpdate()
      this.$set(this.tableData, i, row)
    },
    // 取消
    quxiao(i, row) {
      row.isEdit = false
      if (row.isAdd) {
        this.tableData.splice(i, i + 1)
        this.$set(this.tableData, row)
      } else {
        this.$set(this.tableData, i, row)
      }
    },
    // 删除
    DeleteGR01(id) {
      const that = this
      const path = '/api/services/app/jx0102/Deletejx0102'
      pathReq.dataDelete(path, id).then(res => {
        if (res.status === 200) {
          if (res.data.success) {
            that.GetPagedListGR01s()
          }
        }
      })
    },
    // 新建或修改信息就是保存的时候
    createOrUpdateGR01(i, row) {
      const that = this
      var obj = {}

      if (row.danWei === ('' || null || undefined)) {
        this.$message.error('请输入单位名称')
        return false
      } else if (row.danWeiRenWu === ('' || null || undefined)) {
        this.$message.error('请输入单位任务')
      } else {
        row.ParentId = this.postId
        obj.entityData = row
        const path = '/api/services/app/jx0102/CreateOrUpdatejx0102'
        pathReq.postForm(path, obj).then(res => {
          if (res.status === 200) {
            if (res.data.success) {
              row.isEdit = false
              that.GetPagedListGR01s()
            }
          }
        })
      }
    },
    // 导入
    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1
      if (isLt1M) {
        return true
      }
      this.$message({
        message: 'Please do not upload files larger than 1m in size.',
        type: 'warning'
      })
      return false
    },
    handleSuccess({ results, header }) {
      const filterVal = [
        'danWei',
        'danWeiRenWu',
        'danWeiDiZhi',
        'danWeiYouBian',
        'danWeiDianHua',
        'canYuRenYuan',
        'lianXiRen',
        'lianXiRenDiZhi',
        'lianXiRenYouBian',
        'lianXiRenDianHua',
        'lianXiRenYouXiang',
        'remarks'
      ]
      console.log(results)
      const data = this.formatJson(header, results)
      console.log(data)
      var b = []
      for (var i = 0; i < data.length; i++) {
        const dv = this.formatObj(filterVal, data[i])
        dv.ParentId = this.postId
        b.push(dv)
      }
      this.tableData = b
      this.$bus.emit('detail/upload', this.tableData)
    },

    formatObj(filterVal, data) {
      var result = {}
      for (var i = 0; i < filterVal.length; i++) {
        if (data) {
          result[filterVal[i]] = data[i]
        }
      }
      return result
    },
    // 导出
    exportFn() {
      this.downloadLoading = true
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = [
          '单位名称',
          '单位任务',
          '单位地址',
          '单位邮编',
          '单位电话',
          '参与人员',
          '联系人',
          '联系人地址',
          '联系人邮编',
          '联系人电话',
          '联系人邮箱',
          '备注'
        ]
        const filterVal = [
          'danWei',
          'danWeiRenWu',
          'danWeiDiZhi',
          'danWeiYouBian',
          'danWeiDianHua',
          'canYuRenYuan',
          'lianXiRen',
          'lianXiRenDiZhi',
          'lianXiRenYouBian',
          'lianXiRenDianHua',
          'lianXiRenYouXiang',
          'remarks'
        ]
        const list = this._data.tableData
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: 'danwei', // 非必填
          autoWidth: true, // 非必填
          bookType: 'xlsx' // 非必填
        })
        this.downloadLoading = false
      })
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j]
        })
      )
    }
  }
}
</script>

<style scoped>
/* ffc059 */
</style>
